<div class="container-video flex-center-center" [ngStyle]="{'max-width': width}">
    <video #customVideo src="{{src}}" width="{{width}}" height="{{height}}" muted autoplay loop></video>
</div>
